module.exports = __webpack_public_path__ + "img/6.429719ff.svg";